import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
});

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$color",
})<{ $color: string }>(({ $color }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: $color,
  opacity: 0.35,
}));
